<ui-note
	[type]="noteType$ | async"
	[omitCloseLogic]="true"
	[callToActionType]="CLOSE_TYPE"
	(callToActionClick)="close()"
	[title]="title$ | async"
	*ngIf="showDisclaimer$ | async"
>
	<p>
		{{ body$ | async }}
	</p>
</ui-note>
